import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=5fbddfaa&"
import script from "./OrderTable.vue?vue&type=script&lang=js&"
export * from "./OrderTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fbddfaa')) {
      api.createRecord('5fbddfaa', component.options)
    } else {
      api.reload('5fbddfaa', component.options)
    }
    module.hot.accept("./OrderTable.vue?vue&type=template&id=5fbddfaa&", function () {
      api.rerender('5fbddfaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/OrderTable.vue"
export default component.exports